import { combineReducers } from "redux";
import { getStatusReducer, getErrorReducer } from "../utils/reducer-generators";
import { getInitActionType, getSuccessActionType } from "../utils/get-action-types";
import {
  ADD_SCHEDULE,
  CHANGE_STATUS_SCHEDULE,
  CREATE_TIMESLOTS_FROM_SCHEDULE,
  DELETE_SCHEDULE,
  FETCH_SCHEDULES,
  SET_SELECTED_SCHEDULE,
  UPDATE_SCHEDULE,
} from "../constants/schedules";
import { Action, ScheduleState, SelectedScheduleAction, SelectedScheduleState } from "../models/schedules";

function data(state: ScheduleState = {}, action: Action): ScheduleState {
  switch (action.type) {
    case getSuccessActionType(FETCH_SCHEDULES): {
      const { officeId } = action.data;
      return { ...state, [officeId]: action.payload };
    }
    case getSuccessActionType(DELETE_SCHEDULE): {
      const { officeId, scheduleId } = action.data;
      const schedules = state[officeId];
      return { ...state, [officeId]: schedules.filter((i) => i.id !== scheduleId) };
    }

    case getSuccessActionType(UPDATE_SCHEDULE): {
      const { officeId, scheduleId } = action.data;
      const otherSchedules = state[officeId].filter((i) => i.id !== scheduleId);
      return { ...state, [officeId]: [...otherSchedules, action.payload] };
    }
    default:
      return state;
  }
}

function schedulesAreEdited(state: boolean = false, action: Action): boolean {
  switch (action.type) {
    case getSuccessActionType(DELETE_SCHEDULE):
    case getSuccessActionType(ADD_SCHEDULE):
    case getSuccessActionType(UPDATE_SCHEDULE):
    case getSuccessActionType(CHANGE_STATUS_SCHEDULE):
      return true;
    case getSuccessActionType(CREATE_TIMESLOTS_FROM_SCHEDULE):
      return false;
    default:
      return state;
  }
}

function createTimeslotsResponse(state = {}, action: Action) {
  switch (action.type) {
    case getInitActionType(CREATE_TIMESLOTS_FROM_SCHEDULE):
      return {};
    case getSuccessActionType(CREATE_TIMESLOTS_FROM_SCHEDULE):
      return action.payload;
    default:
      return state;
  }
}

function selected(state: SelectedScheduleState = {}, action: SelectedScheduleAction): SelectedScheduleState {
  switch (action.type) {
    case SET_SELECTED_SCHEDULE:
      return action.payload;

    default:
      return state;
  }
}
const actionsList = [
  FETCH_SCHEDULES,
  DELETE_SCHEDULE,
  ADD_SCHEDULE,
  UPDATE_SCHEDULE,
  CHANGE_STATUS_SCHEDULE,
  CREATE_TIMESLOTS_FROM_SCHEDULE,
];

export default combineReducers({
  status: getStatusReducer(actionsList),
  error: getErrorReducer(actionsList),
  data,
  selected,
  schedulesAreEdited,
  createTimeslotsResponse,
});
